import { render } from "./AttendanceTrigger.vue?vue&type=template&id=49cde838&scoped=true"
import script from "./AttendanceTrigger.vue?vue&type=script&lang=js"
export * from "./AttendanceTrigger.vue?vue&type=script&lang=js"

import "./AttendanceTrigger.vue?vue&type=style&index=0&id=49cde838&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cde838"]])

export default __exports__